import { z } from 'zod/v4';

import { coercedDate } from '../../../utils/coerced-date';

export const driverGroupSchema = z.object({
  driverGroupId: z.number(),
  driverGroupName: z.string(),
  modifiedOn: coercedDate,
  numberOfDrivers: z.number().optional(),
});

export type DriverGroup = z.infer<typeof driverGroupSchema>;
